import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class LogoutInterceptor implements HttpInterceptor {
    constructor(private _router: Router) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        return next.handle(req).pipe(
            tap(
                () => {},
                (error: HttpErrorResponse) => {
                    if (error.status === 401) {
                        this._router.navigate(['account/logout']);
                    }
                }
            )
        );
    }
}



// WEBPACK FOOTER //
// ./src/shared/interceptors/logout.interceptor.ts